// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2nKtI","upload":"Small_upload__3Y32b","imageWrap":"Small_imageWrap__1vc00","removeBtn":"Small_removeBtn__1pf7h"};